export default __webpack_public_path__ + "92928a9d638743ee9b2d35f1b0049905.svg";